import NotificationsLoader from './loader';
export default NotificationsLoader;
//# sourceMappingURL=index.js.map